export const isMobileDevice = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const isNativeApp = () => window.riseupPlatform === 'flutter_web';

export const isIOS = () => {
  if (isNativeApp()) {
    // In Flutter app, use the platform info you're setting
    return window.devicePlatform === 'ios';
  }

  // In web browser, detect iOS devices
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const isAndroid = () => {
  if (isNativeApp()) {
  // In Flutter app, use the platform info you're setting
    return window.devicePlatform === 'android';
  }

  // In web browser, detect Android devices
  return /Android/i.test(navigator.userAgent);
};

export const isIosNativeApp = () => isNativeApp() && isIOS();
export const isAndroidNativeApp = () => isNativeApp() && isAndroid();

const resolvePlatform = (isNative, ios, android) => {
  if (isNative) {
    if (ios) { return 'ios-native'; }
    if (android) { return 'android-native'; }
    return 'unknown-native';
  }
  if (ios) { return 'ios-web'; }
  if (android) { return 'android-web'; }
  return 'desktop-web';
};

export const getPlatformInfo = () => {
  const isNative = isNativeApp();
  const ios = isIOS();
  const android = isAndroid();

  return {
    isNative,
    isIOS: ios,
    isMobile: isMobileDevice(),
    platform: resolvePlatform(isNative, ios, android),
    appVersion: isNative ? window.appVersion : undefined,
  };
};

/**
 * Extracts the major.minor version number from the app version string
 * @param {string} version - Version string (e.g., "1.19.1+47")
 * @returns {number} - Version number (e.g., 1.19) or 0 if invalid
 */
export const getAppVersionNumber = version => {
  if (!version) {
    return 0;
  }
  const parts = version.split('+')[0].split('.');
  return parseFloat(`${parts[0]}.${parts[1]}`);
};
